import { ARSServiceCode } from '@/shared/types/serviceCodes';

export const SERVICE_CODE = ARSServiceCode.CITIZEN_APPEAL_TO_MVS;

export const STEP_NUMBER_SIGN_UP = 5;
export const STEP_NUMBER_DATA_PREVIEW = 4;
